import { Collapse, IconButton } from "@mui/material";
import { CaretDownIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { useId, useState, type ReactNode } from "react";

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  expandedByDefault?: boolean;
  collapsible?: boolean;
};

export function CollapsibleCard({
  title,
  subtitle,
  children,
  expandedByDefault = true,
  collapsible = true,
}: Props) {
  const contentId = useId();
  const [isExpanded, setIsExpanded] = useState(
    collapsible ? expandedByDefault : true,
  );

  const header = (
    <div>
      <div className="text-base font-medium text-text-primary">{title}</div>
      {subtitle ? (
        <div className="text-sm text-text-tertiary">{subtitle}</div>
      ) : null}
    </div>
  );

  return (
    <div className="rounded-3xl bg-white p-4">
      {collapsible ? (
        <button
          type="button"
          className="flex w-full items-center justify-between text-start"
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-controls={contentId}
        >
          {header}

          <IconButton
            component="span"
            role={undefined}
            className="shrink-0"
            size="small"
          >
            <CaretDownIcon
              color="inherit"
              size={20}
              weight="bold"
              className={clsx("transition-transform duration-200", {
                "rotate-180": isExpanded,
              })}
            />
          </IconButton>
        </button>
      ) : (
        <div className="flex items-center justify-between">{header}</div>
      )}

      <Collapse id={contentId} in={isExpanded}>
        <div className="pt-4 break-words">{children}</div>
      </Collapse>
    </div>
  );
}
